import { render } from "./CopyValuePlayers.vue?vue&type=template&id=0aa2c843"
import script from "./CopyValuePlayers.vue?vue&type=script&lang=js"
export * from "./CopyValuePlayers.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__